import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ButtonPrimitiveComponent} from '@tisa-group/client-ui/components/button-primitive';

@Component({
  selector: 'button[tisaButton]',
  templateUrl: './button.component.html',
  styleUrls: ['button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent extends ButtonPrimitiveComponent {}
